export default "__VITE_ASSET__CyzwBZm6__"